import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import classNames from "classnames";

const prefix = "navbar";

const NavBar = ({
  logo,
  bgColor = "#ffffff",
  color = "#000000",
  shadow = false
}) => {
  const componentClass = classNames(`${prefix} box-border h-16`, {
    "shadow-2xl": shadow,
  });

  return (
    <div className={componentClass} style={{
      backgroundColor: bgColor,
      color
    }}>
      <div className="md:container mx-auto flex flex-wrap flex-row">
        <div className={`${prefix}__logo h-full max-h-full`}>
          <Link to="/">
            {logo && <img src={logo} alt="logo" className='max-h-[64px] max-w-[370px]' />}
          </Link>
        </div>
      </div>
    </div>
  );
};

NavBar.propTypes = {
  bgColor: PropTypes.string,
  color: PropTypes.string
};

export default NavBar;
